import React, { useRef } from 'react'

import s from './styles.module.scss'

const DIGITS_COUNT = 6

const TEST_ID = 'digital-input'

type DigitCodeInputProps = {
  digitCode: string
  setDigitCode: (value: string) => void
  disabled?: boolean
  testId?: string
}

export const DigitCodeInput = ({
  disabled,
  digitCode,
  setDigitCode,
  testId: testIdPrefix,
}: DigitCodeInputProps) => {
  const ref = useRef<HTMLInputElement>(null)

  const handleOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setDigitCode(
      e.target.value
        .trim()
        .replace(/[^0-9 ]/g, '')
        .slice(0, DIGITS_COUNT),
    )
  }

  const handleOnFocus = (e: React.FocusEvent<HTMLInputElement>) => {
    e.target.select()
  }

  const handleClick = () => {
    ref.current?.focus()
  }

  return (
    <div
      className={s.container}
      onClick={handleClick}
      data-testid={`${testIdPrefix}-${TEST_ID}-container`}
    >
      <input
        ref={ref}
        value={digitCode}
        spellCheck={false}
        onChange={handleOnChange}
        disabled={disabled}
        onFocus={handleOnFocus}
        placeholder='------'
        className={s.hiddenInput}
        data-testid={`${testIdPrefix}-${TEST_ID}`}
      />
      <div className={s.digitsContainer}>
        {Array.from({ length: DIGITS_COUNT }).map((_, index) => (
          <div key={index} className={s.digitWrapper}>
            {digitCode[index] || <span className={s.digitDefault}>-</span>}
          </div>
        ))}
      </div>
    </div>
  )
}
